export const ITEM_SECTION_HEADER_ROW_HEIGHT = 40
export const MAX_RECENT_SEARCH_RESULTS = 4
export const MAX_DEFAULT_TRENDING_TOKEN_RESULTS_AMOUNT = 8
